import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Mission from "../section/homepage/Mission"
import Service from "../section/homepage/Service"
import About from "../section/homepage/About"
import Contact from "../section/homepage/Contact"
import Hero from "../section/homepage/Hero";
import WatchTutorial from "../section/homepage/Tutorials";
import Testimonials from "../section/homepage/Testimonials";
import Struggling from "../section/homepage/Struggling";
import CourseHighlight from "../section/homepage/CourseHighlight";

export default function Pages(){
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const element = document.getElementById(id);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth" });
                }, 100);
            }
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location]);

    return(
        <div>
            <Header/>
            <Hero/>
            <Struggling/>
            <CourseHighlight/>
            <Mission/>
            <Service/>
            <WatchTutorial/>
            <Testimonials/>
            <About/>
            <Contact/>
            <Footer/>
        </div>
    )
}